import React, { useState, useCallback } from 'react';
import { Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import styles from './ThreeDotMenu.module.css';

function ThreeDotMenu({ options }) {
  const [direction, setDirection] = useState('right');
  const onOpenCallBack = useCallback((e) => {
    const eventTarget = e.target;

    // added setTimeout because node .menu.visible doesn't exist in this thread.
    setTimeout(() => {
      const menu = eventTarget.parentNode.querySelector('.menu.visible');
      if (!menu) return;
      const ellipsisRect = eventTarget.getBoundingClientRect();
      const menuRect = menu.getBoundingClientRect();
      const spaceAtRightSide = document.documentElement.clientWidth - ellipsisRect.x - menuRect.width;
      const directionToBeSet = spaceAtRightSide < 0 ? 'left' : 'right';
      setDirection(directionToBeSet);
    });
  });
  return (
    <Dropdown className={styles.joyn2Dropdown} icon="ellipsis vertical" direction={direction} onOpen={onOpenCallBack}>
      <Dropdown.Menu>
        {options.map((option) => (
          <Dropdown.Item key={option.key} text={option.text} onClick={option.onClick} />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

ThreeDotMenu.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ).isRequired,
};

export default ThreeDotMenu;
